import React from 'react';

const GoldPurchaseDeclaration = ({ billData = {}, customerData = {} }) => {
  const getAadhaarLast4 = (aadhaar) => (aadhaar ? String(aadhaar).slice(-4) : 'N/A');
  const formatDate = (d) => {
    if (!d) return '';
    const dateObj = new Date(d);
    return dateObj.toLocaleDateString();
  };

  const billId = billData?.billId || '';
  const date = formatDate(billData?.billDate || billData?.date);
  const todayFormatted = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date());
  const name = customerData?.name || 'N/A';
  const address = customerData?.address || 'N/A';
  const mobile = customerData?.phone || 'N/A';
  const aadhaarLast4 = getAadhaarLast4(customerData?.aadhaar || '');

  return (

    <div style={{ fontFamily: 'Arial, sans-serif', color: '#000', fontSize: 13 }}>
      <div style={{ margin: '30px' }}></div>

      <div style={{ textAlign: 'center', marginBottom: 10, marginTop: 10 }}>
        <div><strong>Bill ID:</strong> {billId}</div>
      </div>

      <h2 style={{ textAlign: 'center', marginTop: 8 }}>GOLD PURCHASE DECLARATION, CONSENT &amp; INDEMNITY AGREEMENT</h2>

      <p style={{ marginTop: 8 }}>This Gold Purchase Declaration, Consent &amp; Indemnity Agreement ("Agreement") is executed on this {todayFormatted} at Durgapur, West Bengal.</p>

      <h3>1. PARTIES</h3>
      <p><strong>Buyer / Company:</strong><br />Auriksha Edge Private Limited (CIN: U32119WB2025PTC284327), a company incorporated under the Companies Act, 2013, having its registered place of business at: C-11, Central Park, Doc's Colony, City Centre, Bardhaman, Durgapur MC, West Bengal – 713216 (hereinafter referred to as the "Company").</p>

      <p><strong>Seller / Customer:</strong><br />Name: {name || '______________________________'}<br />Address: {address || '_________________________'}<br />Aadhaar No. (last 4 digits only): {aadhaarLast4 || '________'}<br />Mobile No.: {mobile || '________________'}<br />(hereinafter referred to as the "Seller").</p>

      <h3>2. DECLARATION OF OWNERSHIP</h3>
      <p>The Seller hereby solemnly declares and confirms that:</p>
      <ol>
        <li>The gold articles/jewellery sold to the Company are the Seller’s absolute, self-acquired property or lawfully acquired through legitimate sources such as purchase, gift, or inheritance.</li>
        <li>The said gold is free from all charges, liens, encumbrances, pledges, disputes, or third-party claims.</li>
        <li>The gold is not stolen, smuggled, illegally obtained, or connected with any unlawful activity under Indian law.</li>
        <li>The Seller is legally competent to sell the gold under the Indian Contract Act, 1872.</li>
      </ol>

      <h3>3. TESTING, PURITY &amp; VALUATION</h3>
      <ol>
        <li>The Seller understands and agrees that the Company shall test the gold using industry-accepted methods, including but not limited to XRF testing, acid testing, cutting, filing, or melting.</li>
        <li>The final purity, weight, and value shall be determined solely by the Company’s assessment and shall be final and binding on the Seller.</li>
        <li>Stones, beads, enamel, wax, alloys, or non-gold components shall not be considered for valuation.</li>
        <li>If the gold is found to be of lower purity or mixed with non-gold metals, the Company reserves the right to revise the price downward or cancel the transaction.</li>
      </ol>

      <h3>4. MELTING &amp; IRREVERSIBILITY</h3>
      <ol>
        <li>The Seller expressly consents that once the gold is purchased, it may be immediately melted, altered, or refined by the Company.</li>
        <li>After melting or alteration, the Seller shall have <strong>no right whatsoever</strong> to claim return of the same gold articles in original or any other form.</li>
        <li>The transaction shall be treated as final, absolute, and irrevocable.</li>
      </ol>
      <div style={{ pageBreakAfter: 'always', breakBefore: 'page' }} />

      <div style={{ textAlign: 'center', marginBottom: 10, marginTop: 20 }}>
        <div><strong>Bill ID:</strong> {billId}</div>
      </div>

      <h3>5. LEGAL ACTION FOR FALSE DECLARATION / THEFT</h3>
      <ol>
        <li>If at any stage the gold is found to be stolen, fake, spurious, or fraudulently represented, the Company shall have the unrestricted right to:
          <ul>
            <li>Lodge a police complaint/FIR</li>
            <li>Initiate civil and criminal proceedings under applicable laws including IPC, BNS, CrPC/BNSS, and other relevant statutes</li>
            <li>Recover losses, penalties, legal expenses, and damages from the Seller</li>
          </ul>
        </li>
        <li>The Seller shall be solely liable for all legal consequences arising from such misrepresentation.</li>
      </ol>

      <h3>6. INDEMNITY</h3>
      <p>The Seller agrees to indemnify and keep indemnified the Company, its directors, officers, and employees against all losses, claims, damages, penalties, costs, and legal expenses arising out of:</p>
      <ul>
        <li>False declaration of ownership or purity</li>
        <li>Third-party claims</li>
        <li>Theft or illegal sourcing of gold</li>
        <li>Violation of any applicable law</li>
      </ul>

      <h3>7. NO REFUND POLICY</h3>
      <p>Once payment is made and gold is accepted by the Company, <strong>no refund, cancellation, or reversal</strong> shall be permitted under any circumstances, except at the sole discretion of the Company.</p>

      <h3>8. ANTI-MONEY LAUNDERING (AML), KYC &amp; RECORDING CONSENT</h3>
      <ol>
        <li>The Seller consents to Aadhaar-based/Offline KYC as permitted under applicable law and confirms that the Aadhaar details provided are true and correct.</li>
        <li>The Seller authorises the Company to store, verify, and produce KYC records, CCTV footage, call recordings, and transaction data before any authority, court, or investigating agency.</li>
        <li>The Seller acknowledges that the transaction may be reported under the Prevention of Money Laundering Act, 2002 (PMLA) and rules framed thereunder, if required.</li>
        <li>The Seller waives any objection regarding use of such records for legal compliance or defence of the Company.</li>
      </ol>

      <h3>9. LIMITATION OF LIABILITY</h3>
      <ol>
        <li>The Company’s liability, if any, shall be limited strictly to the amount actually paid to the Seller for the gold.</li>
        <li>The Company shall not be liable for indirect, consequential, reputational, or future losses claimed by the Seller.</li>
      </ol>

      <h3>10. WAIVER OF CONSUMER CLAIMS</h3>
      <p>The Seller acknowledges that the transaction is a commercial sale of movable goods after informed testing and consent, and expressly waives any future claim under the Consumer Protection Act, 2019, once payment is accepted.</p>
      <div style={{ pageBreakBefore: 'always', breakBefore: 'page' }} />
      <div style={{ textAlign: 'center', marginBottom: 10, marginTop: 20 }}>
        <div><strong>Bill ID:</strong> {billId}</div>
      </div>
      <h3>11. FORCE MAJEURE</h3>
      <p>The Company shall not be liable for any delay, loss, or non-performance caused by events beyond its reasonable control including fire, theft, natural calamity, riots, strikes, governmental action, or system failure.</p>




      <h3>12. SEVERABILITY</h3>
      <p>If any provision of this Agreement is held invalid or unenforceable by a court, the remaining provisions shall continue to remain valid and enforceable.</p>

      <h3>13. GOVERNING LAW</h3>
      <p>This Agreement shall be governed by and construed strictly in accordance with the laws of India.</p>

      <h3>14. COMPLIANCE WITH LAW</h3>
      <p>This Agreement is governed by and shall be construed in accordance with:</p>
      <ul>
        <li>Indian Contract Act, 1872</li>
        <li>Bharatiya Nyaya Sanhita, 2023</li>
        <li>Bharatiya Nagarik Suraksha Sanhita, 2023</li>
        <li>Prevention of Money Laundering Act, 2002</li>
        <li>Applicable State and Central laws</li>
      </ul>

      <h3>15. JURISDICTION</h3>
      <p>All disputes shall be subject to the exclusive jurisdiction of the competent courts at <strong>Durgapur / Paschim Bardhaman, West Bengal</strong> only.</p>

      <h3>16. CUSTOMER CONSENT &amp; ACKNOWLEDGEMENT</h3>
      <p>The Seller confirms that this Agreement has been read over and explained in a language understood by them, and they have signed it voluntarily without any coercion.</p>

      <div style={{ marginTop: 16 }}>
        <div>Seller Signature: {name}</div>
        <div>Name: {name} </div>
        <div>Date: {todayFormatted}</div>
      </div>


      <div style={{ pageBreakBefore: 'always', breakBefore: 'page' }} />
      <div style={{ textAlign: 'center', marginBottom: 10, marginTop: 20 }}>
        <div><strong>Bill ID:</strong> {billId}</div>
      </div>


      <h2 style={{ textAlign: 'center' }}>স্বর্ণ ক্রয় ঘোষণা, সম্মতি ও ক্ষতিপূরণ চুক্তি (বাংলা সংস্করণ)</h2>
      <p>এই স্বর্ণ ক্রয় ঘোষণা, সম্মতি ও ক্ষতিপূরণ চুক্তি ("চুক্তি") আজ {todayFormatted} তারিখে দুর্গাপুর, পশ্চিমবঙ্গে সম্পাদিত হলো।</p>

      <h3>১. পক্ষসমূহ</h3>
      <p><strong>ক্রেতা / কোম্পানি:</strong><br />Auriksha Edge Private Limited (CIN: U32119WB2025PTC284327), কোম্পানি আইন, ২০১৩ অনুযায়ী গঠিত একটি কোম্পানি, যার ব্যবসায়িক ঠিকানা: C-11, Central Park, Doc's Colony, City Centre, Bardhaman, Durgapur MC, West Bengal – 713216 (পরবর্তীতে "কোম্পানি" নামে অভিহিত)।</p>

      <p><strong>বিক্রেতা / গ্রাহক:</strong><br />নাম: {name || '______________________________'}<br />ঠিকানা: {address || '_________________________'}<br />আধার নম্বর (শেষ ৪ সংখ্যা): {aadhaarLast4 || '________'}<br />মোবাইল নম্বর: {mobile || '________________'}</p>

      <h3>২. মালিকানা ঘোষণা</h3>
      <p>বিক্রেতা এই মর্মে ঘোষণা ও নিশ্চিত করছেন যে: বিক্রিত স্বর্ণালঙ্কার/স্বর্ণ বস্তু বিক্রেতার বৈধ ও সম্পূর্ণ মালিকানাধীন সম্পত্তি এবং এটি কোনো প্রকার বন্ধক, দাবি, ঋণ, মামলা বা তৃতীয় পক্ষের অধিকারের আওতাভুক্ত নয়।</p>

      <h3>৩. বিশুদ্ধতা পরীক্ষা ও মূল্য নির্ধারণ</h3>
      <p>কোম্পানি স্বর্ণের বিশুদ্ধতা যাচাইয়ের জন্য XRF, অ্যাসিড টেস্ট, কাটিং, ফাইলিং বা গলন (melting) পদ্ধতি ব্যবহার করতে পারবে। কোম্পানির দ্বারা নির্ধারিত বিশুদ্ধতা, ওজন ও মূল্যই চূড়ান্ত এবং বিক্রেতার জন্য বাধ্যতামূলক হবে।</p>

      <h3>৪. গলন ও অপরিবর্তনীয়তা</h3>
      <p>বিক্রেতা স্পষ্টভাবে সম্মতি প্রদান করছেন যে ক্রয়ের পর স্বর্ণ অবিলম্বে গলানো বা পরিশোধন করা হতে পারে এবং একবার গলানো হলে বিক্রেতা কোনো অবস্থাতেই উক্ত স্বর্ণ ফেরত দাবি করতে পারবেন না।</p>

      <h3>৫. মিথ্যা ঘোষণা / চুরি সংক্রান্ত আইনগত ব্যবস্থা</h3>
      <p>যদি কোনো পর্যায়ে স্বর্ণ চুরি, জাল বা প্রতারণামূলক প্রমাণিত হয়, তাহলে কোম্পানি আইন অনুযায়ী পুলিশ অভিযোগ (FIR), ফৌজদারি ও দেওয়ানি মামলা দায়ের করতে পারবে এবং সকল ক্ষতি বিক্রেতার নিকট থেকে আদায়যোগ্য হবে।</p>

      <h3>৬. ক্ষতিপূরণ</h3>
      <p>বিক্রেতা কোম্পানি ও তার পরিচালক/কর্মচারীদের সকল প্রকার দাবি, ক্ষতি, জরিমানা ও আইনগত ব্যয়ের বিরুদ্ধে ক্ষতিপূরণ দিতে সম্মত হচ্ছেন।</p>

      <h3>৭. ফেরত নীতির অস্বীকৃতি</h3>
      <p>একবার অর্থ প্রদান ও স্বর্ণ গ্রহণ করা হলে কোনো অবস্থাতেই অর্থ ফেরত বা লেনদেন বাতিলযোগ্য নয়।</p>

      <h3>৮. KYC, PMLA ও রেকর্ড সংরক্ষণে সম্মতি</h3>
      <p>বিক্রেতা আধার ভিত্তিক KYC, CCTV রেকর্ডিং ও প্রয়োজন অনুযায়ী PMLA, ২০০২ অনুসারে রিপোর্টিংয়ের জন্য সম্মতি প্রদান করছেন।</p>
      <div style={{ pageBreakBefore: 'always', breakBefore: 'page' }} />
      <div style={{ textAlign: 'center', marginBottom: 10, marginTop: 20 }}>
        <div><strong>Bill ID:</strong> {billId}</div>
      </div>
      <h3>৯. দায় সীমাবদ্ধতা</h3>
      <p>কোম্পানির দায় কেবলমাত্র বিক্রেতাকে প্রদত্ত অর্থের পরিমাণ পর্যন্ত সীমাবদ্ধ থাকবে।</p>

      <h3>১০. ভোক্তা দাবি পরিত্যাগ</h3>
      <p>বিক্রেতা স্বীকার করছেন যে এটি একটি বাণিজ্যিক বিক্রয় এবং ভবিষ্যতে ভোক্তা আদালতে কোনো দাবি করবেন না।</p>

      <h3>১১. বলপ্রয়োগ বহির্ভূত পরিস্থিতি (Force Majeure)</h3>
      <p>প্রাকৃতিক দুর্যোগ, অগ্নিকাণ্ড, দাঙ্গা, চুরি বা সরকারি নির্দেশের কারণে সৃষ্ট ক্ষতির জন্য কোম্পানি দায়ী থাকবে না।</p>

      <h3>১২. বিচ্ছিন্নতা ধারা</h3>
      <p>এই চুক্তির কোনো অংশ অবৈধ প্রমাণিত হলেও অবশিষ্ট অংশ কার্যকর থাকবে।</p>

      <h3>১৩. প্রযোজ্য আইন ও বিচারাধীনতা</h3>
      <p>এই চুক্তি ভারতের আইন অনুযায়ী পরিচালিত হবে এবং দুর্গাপুর / পশ্চিম বর্ধমান আদালতের একক বিচারাধীনতার আওতাভুক্ত হবে।</p>

      <div style={{ marginTop: 16 }}>
        <div>বিক্রেতার স্বাক্ষর: {name}</div>
        <div>নাম: {name}</div>
        <div>তারিখ: {todayFormatted}</div>
      </div>


    </div>
  );
};

export default GoldPurchaseDeclaration;
